export default __webpack_public_path__ + "static/media/key4.95e6ba4b.png";